import country from '@/utilities/country.js'
import map from '@/utilities/map.js'
import money from '@/utilities/money.js'

export default {
  country,
  map,
  money
}
